import React, { useMemo } from 'react';
import { TableHeader } from 'components/TableHeader';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { PageFormBox } from 'ui/PageFormBox';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { Spin } from 'antd';

const PackageServiceForm = React.lazy(() =>
  import('components/PackageServiceForm')
);

function PackageCreate() {
  useDocumentTitle('Создание услуги');
  useHeaderChanger('Создание услуги');

  const pageBreadCrumbs = useMemo(
    () => [
      {
        id: 1,
        text: 'Услуги',
      },
      {
        id: 2,
        text: 'Все услуги',
        link: '/services/packages',
      },
      {
        id: 3,
        text: 'Создание услуги',
        link: `/services/create`,
      },
    ],
    []
  );

  return (
    <>
      <TableHeader breadcrumbs={pageBreadCrumbs} hideAction />

      <PageFormBox>
        <React.Suspense fallback={<Spin />}>
          <PackageServiceForm />
        </React.Suspense>
      </PageFormBox>
    </>
  );
}

export { PackageCreate };
